//id	crewReport	supervisorReport	vbzNr	duty	dutyFrom	dutyUntil	line	backup1	backup1_reported	backup1_until	backup2	backup2_reported	reportedAtTime	disponent	deleted	reasonId	remarkId	absenceDurationId	createdAt	updatedAt	assignedTo	remarks	zueri9ReasonId	dispoState	zueri9State	zueri9ClientId	zueri9VbzNr	dutyFromLoc	dutyUntilLoc	dutyDateFallback	recordDate	clone	dutySelection	z9Duty	z9DutyFrom	z9DutyFromLoc	z9DutyUntil	z9DutyUntilLoc	z9Line
export default {
  duty: '',
  dutyFrom: null,
  dutyUntil: null,
  line: '',
  backup1: '',
  backup1_reported: false,
  backup1_until: null,
  backup2: '',
  backup2_reported: false,
  reportedAtTime: null,
  disponent: '',
  deleted: false,
  createdAt: null,
  updatedAt: null,
  assignedTo: null,
  remarks: '',
  zueri9ReasonId: null,
  zueri9State: null,
  zueri9ClientId: null,
  zueri9VbzNr: '',
  dutyFromLoc: '',
  dutyUntilLo: '',
  dutyDateFallback: null,
  recordDate: null,
  clone: null,
  dutySelection: '',
};
